import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { ar, en, nl } from "./locales/site";

const storedLanguage = localStorage.getItem("language");
const language = storedLanguage === "nl" || storedLanguage === "en" || storedLanguage === "ar" ? storedLanguage : "ar";
document.documentElement.lang = language;

i18n.use(initReactI18next).init({
  resources: { nl: { translation: nl }, en: { translation: en }, ar: { translation: ar } },
  lng: language,
  fallbackLng: "nl",
  interpolation: { escapeValue: false }
});

i18n.on("languageChanged", (changedLanguage) => {
  document.documentElement.lang = changedLanguage;
});

export default i18n;
